import { render, staticRenderFns } from "./product-information.vue?vue&type=template&id=11a06995&scoped=true"
import script from "./product-information.vue?vue&type=script&lang=js"
export * from "./product-information.vue?vue&type=script&lang=js"
import style0 from "./product-information.vue?vue&type=style&index=0&id=11a06995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a06995",
  null
  
)

export default component.exports